import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="discord-wizard"
export default class extends Controller {
  static targets = ["step", "progressBar", "progressText"]
  static values = { 
    currentStep: Number,
    totalSteps: Number
  }

  connect() {
    this.updateProgress()
  }

  updateProgress() {
    if (this.hasProgressBarTarget && this.hasProgressTextTarget) {
      const percentage = Math.round((this.currentStepValue / this.totalStepsValue) * 100)
      this.progressBarTarget.style.width = `${percentage}%`
      this.progressTextTarget.textContent = `${percentage}% terminé`
    }
  }

  // Handle step navigation
  nextStep(event) {
    if (this.currentStepValue < this.totalStepsValue) {
      this.currentStepValue++
      this.updateProgress()
    }
  }

  previousStep(event) {
    if (this.currentStepValue > 1) {
      this.currentStepValue--
      this.updateProgress()
    }
  }

  // Handle form validation feedback
  showSuccess(message) {
    this.showNotification(message, 'success')
  }

  showError(message) {
    this.showNotification(message, 'error')
  }

  showNotification(message, type) {
    // Create a temporary notification element
    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 p-4 rounded-md shadow-lg z-50 ${
      type === 'success' ? 'bg-green-50 border border-green-200 text-green-700' : 'bg-red-50 border border-red-200 text-red-700'
    }`
    notification.innerHTML = `
      <div class="flex items-center space-x-2">
        <i class="fas fa-${type === 'success' ? 'check-circle' : 'exclamation-circle'}"></i>
        <span>${message}</span>
      </div>
    `
    
    document.body.appendChild(notification)
    
    // Remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification)
      }
    }, 5000)
  }
}